module.exports = __webpack_public_path__ + "static/media/person-placeholder.2b865b6b.svg";